// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Toastr, Button } from "../../revvComponents";

// Components Imports
import { RevvForm } from "../../commonComponents";
import OpportunityDetails from "./OpportunityDetails";

// Actions Imports
import OpportunitiesActions from "../../actions/OpportunitiesActions";
import { createDocumentAndContent } from "../../actions/DocumentActions";

// Internal Imports
import { prepareInitialValues, createForm } from "./methods";
import { GlobalUtils } from "../../utils";
import { PATHS, PIPELINE } from "../../constants";
import CreateDocumentNotes from "../RevvEditor/createDocumentNotes";
import {
  CREATE_QUOTE_FORM_MAP as formJSON,
  FORM_FIELD_RULES,
  FORM_FIELD_MESSAGES,
  INITIAL_VALUES_MAP,
} from "./CreateQuoteFormMap";

// Destructuring
const { getCreateQuoteInitData } = OpportunitiesActions;
const { handleApiErrMsg } = GlobalUtils;
const { DOC_TYPES } = PIPELINE;

class CreateQuotePopup extends Component {
  state = {
    quoteName: "",
    selectedPriceListID: 0,
    renderForm: false,
  };

  componentDidMount() {
    this._createQuoteInitData();
  }

  _createQuoteInitData = () => {
    const { category } = this.props;
    if (category) {
      this.props
        .getCreateQuoteInitData(category)
        .then(response => {
          console.debug(this.props.selectedPriceListIDSelectOptions);
          let selectedPriceListID = 0;
          if (this.props.selectedPriceListIDSelectOptions.length === 1) {
            selectedPriceListID =
              this.props.selectedPriceListIDSelectOptions[0].id;
          }
          this.setState({ quoteName: response, selectedPriceListID }, () => {
            this.setState({ renderForm: true });
          });
        })
        .catch(error => {
          this.setState({ renderForm: true });
          console.error(`CreateQuotePopup => componentDidMount => ${error}`);
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(error),
            timeout: 3000,
          });
        });
    }
  };

  _createDocument = document => {
    // this.setState({ showBtnLoader: true });
    createDocumentAndContent(document)
      .then(details => {
        const { id, doc_no: docNo, template_id: templateID } = details.Document;
        if (!templateID) {
          const { components } = details.Document;
          const notes = new CreateDocumentNotes({
            id,
            components,
            mode: "DOCUMENT",
          });
          const createdNotes = notes.create();
          console.debug(createdNotes);
        }
        // this.setState({ showBtnLoader: false });
        this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${docNo}`);
      })
      .catch(error => {
        console.error(`CreateQuotePopup => _createDocument => ${error}`);
        // this.setState({ showBtnLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _submitData = values => {
    const {
      quoteName,
      documentName,
      selectedPriceListID,
      deadlineDate,
      effectiveStartDate,
      contractStartDate,
      expiryDate,
    } = values;
    const { id: opportunityID, crm_account: { id: accountID } = {} } =
      this.props.opportunity;
    const { category, docURI, templateID, selectedDocCategory } = this.props;
    const document = {
      doc_no: quoteName,
      type: {
        id: category,
      },
      title: documentName,
      opportunity: { id: opportunityID },
      account: { id: accountID },
      pricelist: {
        id: selectedPriceListID,
      },
      deadline_date: deadlineDate,
      meta_values: {},
      uri: docURI,
      template_id: templateID,
    };
    if (selectedDocCategory !== "Security Assessment Questionnaire") {
      document.meta_values.start_date = effectiveStartDate;
      document.meta_values.stop_date = expiryDate;
    }
    if (selectedDocCategory !== "Non Disclosure Agreement") {
      document.meta_values.agreement_start_date = contractStartDate;
    }
    this._createDocument(document);
  };

  _renderForm = () => (
    <React.Fragment>
      <RevvForm
        initialFormValue={prepareInitialValues(
          INITIAL_VALUES_MAP[DOC_TYPES[this.props.selectedDocCategory]],
          this.state,
        )}
        customFieldName={DOC_TYPES[this.props.selectedDocCategory]}
        customFieldComponentRules={FORM_FIELD_RULES}
        customFieldComponentMessages={FORM_FIELD_MESSAGES}
        validateOnChange
        render={formProps => {
          const { values, isValid } = formProps;
          return (
            <React.Fragment>
              {createForm(
                formProps,
                formJSON[DOC_TYPES[this.props.selectedDocCategory]],
                this.props,
              )}
              <div className="createquotepopup-footer popup-footer clearfix">
                <div className="footer-actions">
                  <Button
                    className="btn btn-transparent createquotepopup-footer-cancelbtn"
                    onClick={this.props.closePopup}
                    data-test="createquotepopup-cancel-btn">
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this._submitData(values)}
                    className="btn btn-primary"
                    // isLoading={this.state.showBtnLoader}
                    disabled={!isValid}
                    data-test="createquotepopup-continue-btn">
                    Continue
                  </Button>
                </div>
              </div>
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );

  render() {
    const { show, closePopup } = this.props;
    const { name: opportunityName, crm_account: { name: accountName } = {} } =
      this.props.opportunity;

    const popupHeaderSpace = (
      <div className="pipeline-createquote">
        <span className="pipeline-opportunity">{opportunityName}</span>
        <span className="pipeline-acc">{accountName}</span>
      </div>
    );

    return (
      <div className="createquotepopup">
        <Modal
          open={show}
          onClose={closePopup}
          closeOnOverlayClick={false}
          center>
          <div className="row">
            <div className="col-md-8">
              <div className="popup-form">
                {popupHeaderSpace}
                {this.state.renderForm && this._renderForm()}
              </div>
            </div>
            <OpportunityDetails opportunity={this.props.opportunity} />
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { accounts, opportunitiesByAccount, allPriceLists } =
    state.OpportunitiesStore;
  const { selectedDocCategory } = state.DocumentStore;
  const selectedPriceListIDSelectOptions = allPriceLists.filter(
    pl => pl.active === true,
  );
  return {
    accounts,
    opportunitiesByAccount,
    selectedPriceListIDSelectOptions,
    selectedDocCategory,
  };
};

const mapDispatchToProps = {
  getCreateQuoteInitData: category => getCreateQuoteInitData(category),
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuotePopup);
